import { hosts } from 'settings';

export const ModalUpgrade = {
  bindings: {
    errorMessage: '<',
    text: '<',
    isBundleUpgrade: '<',
    isLoading: '<',
    onSubmit: '&',
  },

  template: `
    <div class="modal modal-upgrade"
      data-show="true"
      data-keyboard="false"
      data-backdrop="false"
      tabindex="-1"
      role="dialog"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content px-4 py-3">
          <div class="modal-body" ng-hide="showConfirmation">
            <header class="font-size-large text-teal-dark text-center">
              Enhance your Voome by adding<br>
              <strong>{{ $ctrl.text.title }}</strong> for only
              <strong>{{ $ctrl.isBundleUpgrade ? '$3' : '$6.99' }} per week</strong>
              {{showConfirmation}}
            </header>
            <div class="py-3">
              <video-player video-id="$ctrl.text.videoId"></video-player>
            </div>
            <p ng-repeat="item in $ctrl.text.items track by $index">
              <strong class="text-green-dark">
                {{ item.title }}
              </strong>
              <br>
              {{ item.description }}
            </p>
            <div class="text-center">
              <button class="btn btn-pill bg-green text-teal-dark mb-3"
                type="button"
                ng-click="showConfirmation = true"
                ng-show="$ctrl.isBundleUpgrade">
                <strong>Upgrade Now</strong>
              </button>
              <button class="btn btn-pill bg-green text-teal-dark mb-3"
                type="button"
                ng-click="$ctrl.onUpgradeRedirect()"
                ng-hide="$ctrl.isBundleUpgrade">
                <strong>Upgrade Now</strong>
              </button>
              <p class="text-teal-dark">
                <strong>
                  For only {{ $ctrl.isBundleUpgrade ? '$3' : '$6.99' }} per week. Change or cancel anytime.</strong>
              </p>
              <a href="#" ng-click="$ctrl.onClickBack()">
                No Thanks.
              </a>
            </div>
          </div>
          <div class="modal-body" ng-show="showConfirmation">
            <div class="d-flex flex-row justify-content-between align-items-start">
              <div class="pt-1">
                <signup-icon color="$ctrl.text.iconColor">
                  <i class="fa fa-lg text-white" ng-class="$ctrl.text.icon"></i>
                </signup-icon>
              </div>
              <div class="pl-3">
                <p>
                  <strong ng-bind="$ctrl.text.title"></strong><br>
                  You will be charged an additional <strong>$3/week</strong>
                  commencing from your next invoice.
                </p>
                <p class="m-0">
                  <a href="#" ng-click="showConfirmation = false">
                    No Thanks.
                  </a>
                  <button class="btn btn-pill bg-green text-teal-dark ml-2"
                    type="button"
                    title="Upgrade Now"
                    ng-click="$ctrl.onSubmit()">
                    <spinner is-loading="$ctrl.isLoading">
                      <strong>
                        <span ng-hide="$ctrl.isLoading">Upgrade</span>
                        <span ng-show="$ctrl.isLoading">Upgrading</span>
                      </strong>
                    </spinner>
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>`,

  controller($element, $sce, $state) {
    'ngInject';

    let interval;

    const setBodyOverflow = value => {
      document.getElementsByTagName('body')[0].style.overflow = value;
    };

    const preventClosingModal = $el => {
      $el.attr('style', 'display: block');
    };

    return {
      $onInit() {
        const $el = $element.find('.modal');

        // Display the modal
        $el.modal();

        // Ensure the modal can't be closed by tampering with the style attr
        interval = setInterval(() => preventClosingModal($el), 500);

        // Fix scrolling issues with the modal
        setBodyOverflow('hidden');
      },

      $onDestroy() {
        clearInterval(interval);
        setBodyOverflow('auto');
      },

      onClickBack() {
        window.history.back();
      },

      onUpgradeRedirect() {
        // Redirect to reset theme on signup page
        window.location.assign(
          $state.href('signupWeekly', {
            slug: 'voome-nutrition',
            coupon: 'PROGRAM-UPGRADE',
          })
        );
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Modal/Upgrade.js